import React from "react";
import SaasProductWizard from "../index";

function LastPassWizard() {
  return <SaasProductWizard productType="lastpass" />;
}

export default LastPassWizard;